import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const CircleErrorIcon: React.FC<SvgIconDefaultProps> = ({
  className,
  testId,
}) => {
  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M12.5 2.08337C6.74689 2.08337 2.08334 6.74692 2.08334 12.5C2.08334 18.2532 6.74689 22.9167 12.5 22.9167C18.2531 22.9167 22.9167 18.2532 22.9167 12.5C22.9167 6.74692 18.2531 2.08337 12.5 2.08337ZM16.438 15.3329C16.7432 15.6381 16.7432 16.1323 16.438 16.4375C16.2854 16.5907 16.0854 16.6667 15.8854 16.6667C15.6854 16.6667 15.4854 16.5907 15.3328 16.4381L12.5 13.6047L9.6672 16.4375C9.51459 16.5907 9.31459 16.6667 9.11459 16.6667C8.91459 16.6667 8.71459 16.5907 8.56199 16.4381C8.25678 16.1329 8.25678 15.6386 8.56199 15.3334L11.3953 12.5L8.56251 9.66723C8.2573 9.36202 8.2573 8.86775 8.56251 8.56254C8.86772 8.25733 9.36199 8.25733 9.6672 8.56254L12.5 11.3954L15.3328 8.56254C15.638 8.25733 16.1323 8.25733 16.4375 8.56254C16.7427 8.86775 16.7427 9.36202 16.4375 9.66723L13.6047 12.5L16.438 15.3329Z"
        fill="white"
      />
    </CustomSvg>
  );
};
export default CircleErrorIcon;
